<template>
    
    <div class="animated fadeIn">
      <b-card no-body>
        <low-stock-report
            :systemid="systemid" />
      </b-card>
    </div>
</template>
<script>
    
  import Vue from 'vue'
  import LowStockReport from './components/LowStockReport'
export default {
    name: 'BookCentreLowStock',
    components: {LowStockReport},
    data: function() {
      return {
        systemid: '2',
      }
    },
    methods: {},
    created: {}
}
</script>

